import React, { Component } from 'react';
import Select from 'react-select';
import { ajaxPost } from '../ajax';
import { customStyles } from '../utils';

// Report "Filter Group": multi-select org-unit filters sent to the report API as
// companyIds / divisionIds / departmentIds / positionIds / locationIds / costCenterIds.
// The backend (EmployeeDBObject.applyFilterGroup) resolves them to employees.
// The value also carries filterGroupDetails, a readable summary of the selection.
const FIELDS = [
    { key: 'companyIds', type: 'COMPANY', label: 'Company', placeholder: 'Company' },
    { key: 'divisionIds', type: 'DIVISION', label: 'Division', placeholder: 'Division' },
    { key: 'departmentIds', type: 'DEPARTMENT', label: 'Department', placeholder: 'Departments' },
    { key: 'positionIds', type: 'POSITION', label: 'Position', placeholder: 'Positions' },
    { key: 'locationIds', type: 'CITY', label: 'Location', placeholder: 'Locations' },
    { key: 'costCenterIds', type: 'COST_CENTER', label: 'Cost Center', placeholder: 'Cost Centers' },
];

export function emptyFilterGroup() {
    var value = {};
    FIELDS.forEach(f => { value[f.key] = []; });
    return value;
}

// Accepts a saved/partial value (e.g. from sessionStorage or previous parameters).
export function normalizeFilterGroup(value) {
    var result = emptyFilterGroup();
    if (value != null) {
        FIELDS.forEach(f => {
            if (Array.isArray(value[f.key])) result[f.key] = value[f.key];
        });
        if (typeof value.filterGroupDetails === 'string') result.filterGroupDetails = value.filterGroupDetails;
    }
    return result;
}

class FilterGroupSection extends Component {
    state = {
        groupList: [],
        isLoading: false,
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ isLoading: true });
        ajaxPost({
            url: "api/Group/search",
            data: {
                "Search": "",
                "includeDeleted": false,
                "startingIndex": 0,
                "itemCount": 1000,
                "Types": FIELDS.map(f => f.type),
            },
            onSuccess: data => {
                if (this._isMounted) this.setState({ groupList: data.content, isLoading: false });
            },
            onError: () => {
                if (this._isMounted) this.setState({ isLoading: false });
            },
            finally: () => { }
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    options(type) {
        return this.state.groupList
            .filter(x => x.Type === type)
            .map(x => ({ label: x.Name === "" ? "Name Not Set" : x.Name, value: x._id }));
    }

    handleChange(key, selected) {
        var value = normalizeFilterGroup(this.props.value);
        value[key] = selected == null ? [] : selected.map(x => x.value);
        // human-readable summary for report headers, e.g. "Department: HR, IT"
        value.filterGroupDetails = FIELDS
            .filter(f => value[f.key].length > 0)
            .map(f => f.label + ": " + this.options(f.type).filter(x => value[f.key].includes(x.value)).map(x => x.label).join(", "))
            .join("\n");
        this.props.onChange(value);
    }

    render() {
        var value = normalizeFilterGroup(this.props.value);
        return (
            <div>
                <h4 style={{ marginBottom: 6 }}>Filter Group</h4>
                {FIELDS.map(f => {
                    var options = this.options(f.type);
                    return (
                        <div key={f.key} style={{ marginBottom: 6 }}>
                            <label>{f.label}</label>
                            <Select placeholder={f.placeholder}
                                options={options}
                                styles={customStyles}
                                isMulti
                                isLoading={this.state.isLoading}
                                onChange={this.handleChange.bind(this, f.key)}
                                value={options.filter(x => value[f.key].includes(x.value))} />
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default FilterGroupSection;
